/* eslint-disable no-prototype-builtins */
import axios from 'axios';
import { getOr } from 'lodash/fp';

const baseURL = `${process.env.GATSBY_API_URL}`;
const makeEndpoint =
  (method, url) =>
  ({ params, data } = {}) =>
    axios
      .request({
        url,
        method,
        params,
        data,
        headers:
          method === 'get' ? undefined : { 'Content-Type': 'application/json' },
        baseURL,
      })
      .then((response) => response.data);

let store = {};

export const setStore = (data) => {
  store = data;
};

const authHeader = () => {
  const state = store.getState();
  const user = getOr(false, ['auth', 'user'], state);
  // return auth header with jwt if user is logged in
  const token = getOr(null, 'jwtToken', user);
  const isLoggedIn = !!(user && token);
  if (isLoggedIn) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

function handleResponse(response, preserveErrorData = false) {
  const state = store.getState();
  const user = getOr(false, ['auth', 'user'], state);

  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if ([401, 403].includes(response.status) && user) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        // logout();
        // console.log('logout with 401,403');
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(preserveErrorData ? data : error);
    }

    return data;
  });
}

const get = (url) => {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  return fetch(`${baseURL}${url}`, requestOptions).then(handleResponse);
};

const post = (url, body = {}, preserveErrorData = false) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    credentials: 'include',
    body: JSON.stringify(body),
  };
  return fetch(`${baseURL}${url}`, requestOptions).then((res) =>
    handleResponse(res, preserveErrorData)
  );
};

const file = (url, body = {}) => {
  return axios
    .request({
      url,
      method: 'post',
      data: body,
      headers: { ...authHeader() },
      withCredentials: true,
      baseURL,
    })
    .then((response) => response.data);
};

const put = (url, body) => {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeader(url) },
    body: JSON.stringify(body),
  };
  return fetch(`${baseURL}${url}`, requestOptions).then(handleResponse);
};

const serialize = (obj) => {
  const str = [];
  for (const p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  return str.join('&');
};

const deleteRequest = (url) => {
  const requestOptions = {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    credentials: 'include',
  };
  return fetch(`${baseURL}${url}`, requestOptions).then((res) =>
    handleResponse(res)
  );
};

const fetchWrapper = {
  get,
  post,
  put,
  file,
  serialize,
  makeEndpoint,
  deleteRequest,
};

export default fetchWrapper;
